export default function ({condition, children}) {
	if (condition) {
		return children();
	}

	return null;
}


// WEBPACK FOOTER //
// ./src/components/if.js